/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import React, { Component } from 'react';
import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
// import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function getRowClass ( params ) {

    if ( params.data.weekEnding.toString() === params.data.selectedWeek.toString() ) {

        return 'selected-row';

    }
    return null;

}

const weekNumberValueGetter = params => {

    if ( params.data.fiscalMonthName === 'JAN00' ) return 'Inventory';
    if ( params.data.fiscalMonthName === 'FEB00' ) return 'Rework';

    return params.data.weekNumber;

};

const totalCapValueGetter = params => {

    if ( params.data.quantity === null ) return 'Infinite Availability';

    return params.data.quantity.totalCapacity;

};

const showInfinity = value => {
    if ( value >= 99999 ) return 'Infinite';
    return value;
};

const colDefs = [
    {
        headerName: 'Week',
        sortable: false,
        filter: false,
        width: 60,
        valueGetter: weekNumberValueGetter,
        colSpan: function ( params ) {

            return ( params.data.fiscalMonthName === 'JAN00' || params.data.fiscalMonthName === 'FEB00' ) ? 3 : 1;

        }
    },
    {
        field: 'weekEndingString',
        headerName: 'Ending',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'fiscalMonthName',
        headerName: 'Month',
        sortable: true,
        filter: true,
        width: 80,
        cellClass: 'centerText'
    },
    {
        headerName: 'Total Cap',
        sortable: true,
        width: 80,
        valueGetter: totalCapValueGetter,
        colSpan: function ( params ) {

            let colspan = 1;
            if ( params.data.quantity === null ) {

                if ( params.data.reportType === 'Combo' ) colspan = 5;
                else colspan = 6;

            }
            return colspan;

        }
    },
    {
        field: 'quantity.totalAvailable',
        headerName: 'Total Availability',
        sortable: true,
        width: 120,
        valueFormatter: params => showInfinity( params.value ),
        cellClassRules: {
            'atp-order-availability-result-red-cell': 'x < 0'
        }
    },
    {
        field: 'quantity.totalRunningAvailable',
        headerName: 'Running Availability',
        sortable: true,
        width: 140,
        valueFormatter: params => showInfinity( params.value )
    },
    {
        field: 'quantity.maximumQty',
        headerName: 'Maximum',
        sortable: true,
        width: 90,
        valueFormatter: params => showInfinity( params.value )
    },
    {
        field: 'quantity.forecastQty',
        headerName: 'Forecast',
        sortable: true,
        width: 90,
        valueFormatter: params => showInfinity( params.value )
    },
    {
        field: 'quantity.flexQty',
        headerName: 'Flexible Qty',
        sortable: true,
        width: 100,
        valueFormatter: params => showInfinity( params.value )
    }, {
        field: 'totalOrdered',
        headerName: 'Total Ordered',
        sortable: true,
        width: 110,
        valueFormatter: params => showInfinity( params.value ),
        cellRenderer: params => {

            if ( params.value === 0 ) return ( <span>{params.valueFormatted}</span> );
            return ( <a href={`/${params.data.unitName}/constraints/check-orders-by-constraint-build-weeks?constrainttype=${params.data.ctype}&constraintkey=${params.data.ckey}&beginweek=${formatGivenDate( params.data.weekEnding, 'YYYY-MM-DD' )}&endweek=${formatGivenDate( params.data.weekEnding, 'YYYY-MM-DD' )}`} target="_blank" rel="noopener noreferrer">{params.valueFormatted}</a> );

        }
    }
];
const defaultColDef = {
    cellClassRules: {
        oddRowBackground: function ( params ) {

            return params.rowIndex % 2 === 0;

        }
    }
};
const excelStyles = [
    {
        id: 'greenBackground',
        interior: {
            color: '#b5e6b5',
            pattern: 'Solid'
        }
    },
    {
        id: 'centerText',
        alignment: {
            horizontal: 'Center'
        }
    },
    {
        id: 'redFont',
        font: {
            fontName: 'Calibri Light',
            underline: 'Single',
            italic: true,
            color: '#ff0000'
        }
    },
    {
        id: 'oddRowBackground',
        interior: {
            color: '#f7f7f7',
            pattern: 'Solid'
        }
    },
    {
        id: 'boldBorders',
        borders: {
            borderBottom: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            },
            borderLeft: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            },
            borderRight: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            },
            borderTop: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            }
        }
    },
    {
        id: 'header',
        interior: {
            color: '#CCCCCC',
            pattern: 'Solid'
        },
        borders: {
            borderBottom: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            },
            borderLeft: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            },
            borderRight: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            },
            borderTop: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            }
        }
    },
    {
        id: 'dateFormat',
        dataType: 'dateTime',
        numberFormat: { format: 'mm/dd/yyyy;@' }
    },
    {
        id: 'twoDecimalPlaces',
        numberFormat: { format: '#,##0.00' }
    },
    {
        id: 'textFormat',
        dataType: 'string'
    },
    {
        id: 'bigHeader',
        font: { size: 25 }
    },
    {
        id: 'regularHeader',
        font: { size: 14 }
    }
];
class OrderAvailabilityTable extends Component {

    onGridReady = params => {

        this.gridApi = params.api;

        setTimeout( () => {

            this.gridApi.sizeColumnsToFit();

        }, 500 );

    }

    exportExcel = () => {

        const colKeys = this.gridApi.getAllGridColumns();
        const message = `${this.props.oaKey} Order Availablity as of ${new Date()}`;
        const unit = this.props.results.length ? this.props.results[0].unitName : '';
        const cType = this.props.results.length ? this.props.results[0].ctype : '';
        const title = `Order Availability - ${unit} - ${cType} - ${this.props.oaKey}`;
        const generalParams = {
            fileName: title,
            sheetName: `${cType} - ${this.props.oaKey}`,
            exportMode: 'xlsx',
            columnKeys: colKeys,
            prependContent: [
                [],
                [
                    {
                        styleId: 'regularHeader',
                        data: {
                            type: 'String',
                            value: message
                        },
                        mergeAcross: 10
                    }
                ],
                []
            ]
        };

        this.gridApi.exportDataAsExcel( generalParams );

    };

    render () {

        const message = `${this.props.oaKey} Order Availablity as of ${new Date()}`;
        const displayColDefs = [...colDefs];
        if ( this.props.results.length && this.props.results[0].reportType === 'Combo' ) displayColDefs.splice( 5, 1 );
        return (

            <section className="atp-search-result-panel order-availability-result-panel ">

                <div className="results-message">
                    {message}
                </div>

                <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
                    <AgGridReactComponent
                        reactNext={true}
                        columnDefs={displayColDefs}
                        defaultColDef={defaultColDef}
                        rowData={this.props.results}
                        excelStyles={excelStyles}
                        onGridReady={this.onGridReady}
                        getRowClass={getRowClass}
                    />
                </div>

            </section>
        );

    }

}

OrderAvailabilityTable.propTypes = {
    results: PropTypes.array.isRequired,
    time: PropTypes.number,
    oaKey: PropTypes.string
};
export default OrderAvailabilityTable;
